import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Table, TableBody, TableContainer } from '@mui/material';
import { isEmpty } from 'lodash';
import { useSelector } from '../../redux/store';
import { tableStyle } from '../../styles/NewLead';
import { AUDIENCE_PREVIEW_TABLE_CONST, AUDIENCE_PREVIEW_TABLE_CONST_WITHOUT_STATUS } from '../../constants/Campaign';
import Scrollbar from '../Scrollbar';
import { TableEmptyRows, TableHeadCustomV2, TableNoData } from '../table';
import AudiencePreviewTableRow from './AudiencePreviewTableRow';
import { emptyRows } from '../../hooks/useTable';

const CampaignAudiencePreviewTable = ({ dense, rowsPerPage, page, handleUnsubscribeLead, filteredData }) => {
    const [tableData, setTableData] = useState([]);

    const { existingAudienceLeadList: { results: existingAudienceLeadListResults } } = useSelector((state) => state.lead);

    useEffect(() => {
        if (isEmpty(existingAudienceLeadListResults)) {
            setTableData(existingAudienceLeadListResults);
            return;
        }
        const tempTableData = existingAudienceLeadListResults?.map((el) => ({ ...el, lead_id: el?.id, is_disabled: false }));
        setTableData(tempTableData);
    }, [existingAudienceLeadListResults]);

    useEffect(() => {
        if (filteredData && filteredData.length > 0) {
            setTableData(filteredData)
        }
    }, [filteredData]);

    const isNotFound = filteredData ? filteredData.length === 0 : (tableData?.length === 0 && existingAudienceLeadListResults?.length === 0);

    return <Box sx={{ position: 'relative', '&:last-of-type .MuiAccordion-root': { border: 'none' } }}>
        <Box>
            {/* search box */}
        </Box>
        <Scrollbar sx={{ pl: '0', pr: '0' }}>
            <TableContainer sx={{ maxHeight: '457px', border: '1px solid rgba(241, 243, 244, 1)' }}>
                <Table size={dense ? 'small' : 'medium'} sx={tableStyle} stickyHeader>
                    <TableHeadCustomV2
                        headLabel={filteredData && filteredData.length ? AUDIENCE_PREVIEW_TABLE_CONST_WITHOUT_STATUS : AUDIENCE_PREVIEW_TABLE_CONST}
                        rowCount={tableData?.length}
                        leadTable
                        tableHeadCustom
                    />
                    <TableBody>
                        {tableData?.length > 0 && tableData.map((row, index) =>
                            <AudiencePreviewTableRow
                                row={row}
                                key={index}
                                handleUnsubscribeLead={handleUnsubscribeLead}
                                showStatus={!filteredData?.length}
                            />
                        )}
                        {(filteredData && filteredData.length === 0) || (tableData?.length === 0 && existingAudienceLeadListResults?.length === 0) &&
                            <>
                                <TableEmptyRows emptyRows={emptyRows(page, rowsPerPage, tableData.length)} />
                                {isNotFound && <TableNoData isNotFound={isNotFound} />}
                            </>}
                    </TableBody>
                </Table>
            </TableContainer>
        </Scrollbar>
    </Box>;
};

export default CampaignAudiencePreviewTable;

CampaignAudiencePreviewTable.propTypes = {
    dense: PropTypes.bool,
    rowsPerPage: PropTypes.any,
    page: PropTypes.any,
    handleUnsubscribeLead: PropTypes.func,
    filteredData: PropTypes.array
};